import { usePageWidth } from '@fs/zion-ui'

export default function useDeviceSize() {
  const atWidth = usePageWidth()
  const deviceSize = atWidth({ default: 'phone', md: 'tablet', lg: 'desktop' })

  return { isTabletOrSmaller: deviceSize === 'tablet' || deviceSize === 'phone', isPhone: deviceSize === 'phone' }
}
